import { useTranslation } from 'react-i18next';

import { Badge } from '@kognitos/lattice';

export function DeactivatedBadge() {
  const { t } = useTranslation('automation');

  return (
    <Badge variant="destructive" data-testid="automation-deactivated-badge">
      {t('automation.deactivated')}
    </Badge>
  );
}
